/**
 * AddSubscriptionPlanCtrl controller
 * Add/edit categories
 */

/**
 * AddSubscriptionPlanCtrl controller
 *
 * @class AddSubscriptionPlanCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddSubscriptionPlanCtrl
 */
/* @ngInject */
export default function AddSubscriptionPlanCtrl ($uibModalInstance, $scope, SubscriptionPlan, plan, alertLiteSvc) {
  var vm = this
  vm.plan = plan
  vm.isNew = !plan.subscriptionPlanSettingsId

  /**
   * Upload logo
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   * @function
   */
  function uploadLogo (file, type) {
    return plan._uploadFile(null, file, {
      type
    }).data()
  }

  vm.uploadIcon = (file) => {
    $scope.form.$setDirty()
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      _URL.revokeObjectURL(objectUrl)
      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (this.width * this.height > 16800000) {
        alertLiteSvc.alertError('Max resolution of image is 16.8MPx')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return uploadLogo(file, 'cover_subscription')
        .then((url) => {
          vm.plan.coverImageUrl = url
        }).finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
  }

  vm.save = function () {
    plan._save().then(res => {
      $uibModalInstance.close(new SubscriptionPlan({ ...res.data, id: res.data.subscriptionPlanSettingsId, networkId: plan.networkId }))
    })
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
